import { getProductImageUrl, getValidImageUrls } from './productImage';
import { getEffectivePrice } from './productPricing';
import {
    buildCartLineIdFromSelection,
    getDefaultSelection,
    normalizeProductVariants,
    selectionToSelectedOptions,
    getVariantUnitPrice,
} from './productVariants';

export const getPrimaryIdentifier = (item) => item?._id || item?.id || item?.productId;

export const identifiersMatch = (item, targetId) => {
    if (!item || targetId === undefined || targetId === null) return false;
    const idCandidates = [item._id, item.id, item.productId].filter(Boolean).map(String);
    return idCandidates.includes(String(targetId));
};

export const buildCartItemFromWishlist = (item) => {
    const productId = getPrimaryIdentifier(item);
    const { options, variants } = normalizeProductVariants(item);
    const selection = getDefaultSelection(options, variants);
    const selectedOptions = selectionToSelectedOptions(options, selection);
    const variant =
        variants.find((v) =>
            options.every((opt, i) => {
                const selected = selection[opt.name];
                if (!selected) return true;
                return String(v[`option${i + 1}`] || '').toLowerCase() === String(selected).toLowerCase();
            })
        ) || variants[0] || null;

    const variantImage = getValidImageUrls(variant?.images)[0];
    const imageUrl = variantImage || getProductImageUrl(item);

    // Legacy size/color for older cart UI fallbacks
    const sizeOpt = selectedOptions.find((o) => /size/i.test(o.name));
    const colorOpt = selectedOptions.find((o) => /colou?r/i.test(o.name));

    return {
        productId,
        name: item.name,
        description: item.description,
        quantity: 1,
        price: getVariantUnitPrice(item, variant, getEffectivePrice),
        originalPrice: variant?.price != null ? Number(variant.price) : item.price,
        discount: item.discount || 0,
        category: item.category,
        subCategory: item.subCategory,
        brand: item.brand,
        imageUrl,
        selectedOptions,
        size: sizeOpt?.value || null,
        color: colorOpt?.value || null,
        cartLineId: buildCartLineIdFromSelection(productId, selectedOptions),
        variantTitle: variant?.title || null,
        sku: variant?.sku || null,
    };
};

export const normalizeWishlistProduct = (product) => {
    if (!product) return null;

    const normalizedImage = Array.isArray(product.imageUrl)
        ? product.imageUrl[0]
        : product.imageUrl;

    return {
        ...product,
        imageUrl: getProductImageUrl(product) || normalizedImage,
    };
};
